import { render, staticRenderFns } from "./star-full.vue?vue&type=template&id=4a86a690"
import script from "./star-full.vue?vue&type=script&lang=js"
export * from "./star-full.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports